import { gql, useQuery } from "@apollo/client";
import { AsyncQueryStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { PERMIT_TEMPLATE_FIELDS } from "../fragments/PermitTemplate";

export const GET_PERMIT_BLUEPRINTS = gql`
  ${PERMIT_TEMPLATE_FIELDS}
  query GetPermitBlueprints {
    permitBlueprints {
      id
      key
      name
      template {
        ...PermitTemplateFields
      }
    }
  }
`;

export function useGetPermitBlueprints() {
  const { loading, error, data, refetch } = useQuery(GET_PERMIT_BLUEPRINTS, {
    fetchPolicy: "cache-and-network",
    errorPolicy: "all",
  });

  return {
    data,
    refetch,
    status: {
      loading,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncQueryStatus,
  };
}
